"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const button_1 = __importStar(require("@app/routes/SpeechDevelopment/button"));
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const smallHeader_1 = __importDefault(require("@components/smallHeader"));
const title_1 = __importDefault(require("@app/routes/SpeechDevelopment/title"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const audioPathNames_1 = require("@app/enums/audioPathNames");
const helpers_1 = require("@app/helpers");
const uiConfigs_1 = require("@app/constants/uiConfigs");
const exercise_1 = require("@app/components/container/exercise");
const Pagination_1 = require("@components/Pagination");
const boxComponentWithImg_1 = __importDefault(require("@app/routes/SpeechDevelopment/boxComponentWithImg"));
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const sendInfoReport_1 = require("@app/utils/sendInfoReport");
const uiConfigs_2 = require("@app/utils/uiConfigs");
const DropContainerWrapper = styled_components_1.default.div `
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    align-items: self-start;
    justify-content: end;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
    @media (max-width: 700px) {
        flex-wrap: wrap-reverse;
    }
`;
const Description = styled_components_1.default.div `
    font-size: 30px;
    font-weight: bold;
    color: white;
    text-align: center;
    @media (max-width: 850px) {
        font-size: 18px;
        padding: 4px 15px;
    }

    @media (max-width: 540px) {
        font-size: 18px;
        padding: 3px 10px;
        font-weight: 700;
    }
`;
let index = 0;
let timeoutId = null;
let newRepeatAgain = null;
function checkOrder(array1, array2) {
    const length1 = array1.length;
    for (let i = 0; i <= array2.length - length1; i++) {
        let isInOrder = true;
        for (let j = 0; j < length1; j++) {
            if (array2[i + j] !== array1[j]) {
                isInOrder = false;
                break;
            }
        }
        if (isInOrder) {
            return true;
        }
    }
    return false;
}
function checkWordsInArrays(array1, array2) {
    const set2 = new Set(array2);
    return array1.some(word => set2.has(word));
}
let infoRep = [];
let checkedAnswers = [];
const Disinhibition = ({ response, description, timer, langId }) => {
    const [data, setData] = (0, react_1.useState)([]);
    const [initialData, setInitialData] = (0, react_1.useState)([]);
    const [title, setTitle] = (0, react_1.useState)('');
    const [recognizer, setRecognizer] = (0, react_1.useState)(null);
    const [isRecognizing, setIsRecognizing] = (0, react_1.useState)(false);
    const recognizedWords = (0, react_1.useRef)([]);
    const wrongAnswerCount = (0, react_1.useRef)(0);
    const [customAnswer, setCustomAnswer] = (0, react_1.useState)('');
    const [isLongText, setIsLongText] = (0, react_1.useState)(false);
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(false);
    const [currentCardIndex, setCurrentCardIndex] = (0, react_1.useState)(0); // Индекс текущей карточки
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const handleAddCoin = () => {
        addCoin(3, 5);
    };
    const getLabel = () => {
        if (+langId === 1) {
            return isRecognizing ? "Стоп" : "Старт";
        }
        return isRecognizing ? "Stop" : "Start";
    };
    const [checkButtons, setCheckButtons] = (0, react_1.useState)((0, helpers_1.generateInitialState)(10));
    const checkButtonRef = (0, react_1.useRef)((0, helpers_1.generateInitialState)(10));
    const startRecognition = (options, itemData, index) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            setIsDisabled(true);
            const newOptions = (_a = itemData === null || itemData === void 0 ? void 0 : itemData.content) === null || _a === void 0 ? void 0 : _a.replace('*', options[0]).split(' ');
            const cleanedOptions = (_b = newOptions.map(word => word.replace(/[.,]/g, ''))) === null || _b === void 0 ? void 0 : _b.map(item => item === null || item === void 0 ? void 0 : item.toLowerCase());
            const isRightWordPreposition = audioPathNames_1.prepositions.includes((_c = itemData.right_word) === null || _c === void 0 ? void 0 : _c.toLowerCase());
            const filteredOptions = isRightWordPreposition
                ? cleanedOptions
                : cleanedOptions.filter(word => !audioPathNames_1.prepositions.includes(word));
            // let a = {
            //     "rep_id": this.indxCurrentRepetition,
            //     "system_time": parseFloat(timeOfRepetition.toFixed(1)),
            //     "category_name": this.currentCategory
            // }
            infoRep = [...infoRep, { rep_id: itemData === null || itemData === void 0 ? void 0 : itemData.id, category_name: '', system_time: '', startTime: Date.now() }];
            const stream = yield window.navigator.mediaDevices.getUserMedia({
                audio: {
                    sampleRate: 16000,
                    sampleSize: 16,
                    channelCount: 1,
                },
            });
            const additionalWords = ((_d = initialData === null || initialData === void 0 ? void 0 : initialData[index]) === null || _d === void 0 ? void 0 : _d.additional_words) || [];
            const additionalCorrectWords = ((_e = initialData === null || initialData === void 0 ? void 0 : initialData[index]) === null || _e === void 0 ? void 0 : _e.additional_correct_words) || [];
            // @ts-ignore
            const recognizerInstance = new window.RecognizerSpeechDev(((_f = [
                ...(filteredOptions || []),
                ...additionalWords,
                ...additionalCorrectWords.filter(item => { var _a; return item !== ((_a = itemData === null || itemData === void 0 ? void 0 : itemData.right_word) === null || _a === void 0 ? void 0 : _a.toLowerCase()); })
            ]) === null || _f === void 0 ? void 0 : _f.length) === 1 && +langId === 2 ? [(_g = initialData === null || initialData === void 0 ? void 0 : initialData[index]) === null || _g === void 0 ? void 0 : _g.right_word, 'start', 'stop', 'fake', 'word'] : [
                ...(filteredOptions || []),
                ...additionalWords,
                ...additionalCorrectWords.filter(item => { var _a; return item !== ((_a = itemData === null || itemData === void 0 ? void 0 : itemData.right_word) === null || _a === void 0 ? void 0 : _a.toLowerCase()); }),
            ]);
            yield recognizerInstance.init(stream, langId);
            setIsDisabled(false);
            setRecognizer(recognizerInstance);
            setIsRecognizing(true);
            if (itemData === null || itemData === void 0 ? void 0 : itemData.full_question_audio) {
                audioPlayer_1.audioPlayer.stopAudio();
                audioPlayer_1.audioPlayer.playAudio(null, itemData === null || itemData === void 0 ? void 0 : itemData.full_question_audio);
            }
            else if (itemData === null || itemData === void 0 ? void 0 : itemData.audio) {
                audioPlayer_1.audioPlayer.stopAudio();
                audioPlayer_1.audioPlayer.playAudio(null, itemData === null || itemData === void 0 ? void 0 : itemData.audio);
            }
            document.addEventListener('recognizeWordEvent', (e) => handleRecognizeWordEvent(e, filteredOptions, index));
            timeoutId = setInterval(() => {
                recognizedWords.current = [];
                wrongAnswerCount.current++;
                handleAnswer(false, true);
            }, timer ? timer : (isLongText ? 33000 : 28000));
        }
        catch (error) {
            console.error('Error accessing microphone:', error);
        }
    });
    const stopRecognition = () => {
        if (recognizer) {
            recognizer.stop();
            setIsRecognizing(false);
            recognizedWords.current = [];
            index = 0;
            wrongAnswerCount.current = 0;
            setCurrentCardIndex(0);
            setCustomAnswer(prev => prev ? '' : prev);
            setCheckButtons(uiConfigs_1.initialButtonState);
            checkedAnswers = uiConfigs_1.initialButtonState;
            checkButtonRef.current = uiConfigs_1.initialButtonState;
        }
        if (timeoutId) {
            clearInterval(timeoutId);
        }
    };
    const handleRecognizeWordEvent = (e, newOptions, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const word = ((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.word) || '';
        if (!recognizedWords.current.includes(word)) {
            recognizedWords.current.push(word);
        }
        let isCorrect;
        if ((response === null || response === void 0 ? void 0 : response.slug) === 'chasti-tela') {
            isCorrect = word === ((_c = (_b = data[index || currentCardIndex]) === null || _b === void 0 ? void 0 : _b.right_word) === null || _c === void 0 ? void 0 : _c.toLowerCase());
            // TODO } else if (index >= 0 && additionalWordsBySlug[response?.slug] && additionalWordsBySlug[response?.slug]?.[index]?.additionalCorrectWords?.length) {
        }
        else if (index >= 0 && ((_e = (_d = initialData === null || initialData === void 0 ? void 0 : initialData[index]) === null || _d === void 0 ? void 0 : _d.additional_correct_words) === null || _e === void 0 ? void 0 : _e.length)) {
            // itemData?.content?.replace('*', options[0]).split(' ')
            // data[index || currentCardIndex]
            const correctAnswer = (_g = (_f = initialData === null || initialData === void 0 ? void 0 : initialData[index]) === null || _f === void 0 ? void 0 : _f.additional_correct_words) === null || _g === void 0 ? void 0 : _g.map(elem => {
                var _a, _b, _c;
                const currentOptions = (_b = (_a = data[index || currentCardIndex]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.replace('*', elem).split(' ');
                const cleanedOptions = (_c = currentOptions.map(word => word.replace(/[.,]/g, ''))) === null || _c === void 0 ? void 0 : _c.map(item => item === null || item === void 0 ? void 0 : item.toLowerCase());
                const isRightWordPreposition = audioPathNames_1.prepositions.includes(elem === null || elem === void 0 ? void 0 : elem.toLowerCase());
                return ({
                    text: isRightWordPreposition
                        ? cleanedOptions
                        : cleanedOptions.filter(word => !audioPathNames_1.prepositions.includes(word)),
                    elem,
                });
            }).find(item => {
                return checkOrder(item === null || item === void 0 ? void 0 : item.text, recognizedWords === null || recognizedWords === void 0 ? void 0 : recognizedWords.current);
            });
            if (correctAnswer) {
                isCorrect = true;
                setCustomAnswer(correctAnswer.elem);
            }
            else {
                isCorrect = false;
            }
        }
        else {
            isCorrect = checkOrder(newOptions, recognizedWords.current);
        }
        // isCorrect = response?.slug === 'chasti-tela' ? word === data[index || currentCardIndex]?.right_word?.toLowerCase() : checkOrder(newOptions, recognizedWords.current);
        if (!['Povtory_glagoly_1', 'Povtory_predlogi_room'].includes(response === null || response === void 0 ? void 0 : response.slug)) {
            const updatedData = data === null || data === void 0 ? void 0 : data.map((item, idx) => {
                if ((isCorrect) && ((index || currentCardIndex) === idx)) {
                    return (Object.assign(Object.assign({}, item), { isCorrect: true, isChecked: true }));
                }
                return item;
            });
            setData(updatedData);
        }
        const isRightWordArray = ((_l = (_k = (_j = (_h = data[index || currentCardIndex]) === null || _h === void 0 ? void 0 : _h.right_word) === null || _j === void 0 ? void 0 : _j.trim()) === null || _k === void 0 ? void 0 : _k.split(' ')) === null || _l === void 0 ? void 0 : _l.length) > 1;
        const rightWord = isRightWordArray ? (_q = (_p = (_o = (_m = data[index || currentCardIndex]) === null || _m === void 0 ? void 0 : _m.right_word) === null || _o === void 0 ? void 0 : _o.trim()) === null || _p === void 0 ? void 0 : _p.split(' ')) === null || _q === void 0 ? void 0 : _q.map(item => item === null || item === void 0 ? void 0 : item.toLowerCase()) : (_s = (_r = data[index || currentCardIndex]) === null || _r === void 0 ? void 0 : _r.right_word) === null || _s === void 0 ? void 0 : _s.toLowerCase();
        const handleIncorrectAnswer = () => {
            if (isRightWordArray) {
                newRepeatAgain = setTimeout(() => {
                    var _a, _b, _c, _d, _e, _f;
                    if (!isCorrect && (recognizedWords.current.includes(rightWord[0]) || recognizedWords.current.includes(rightWord[2]) || recognizedWords.current.includes(rightWord[1])) && !((_b = (_a = checkButtonRef === null || checkButtonRef === void 0 ? void 0 : checkButtonRef.current) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.isChecked)) {
                        wrongAnswerCount.current++;
                        audioPlayer_1.audioPlayer.stopAudio();
                        audioPlayer_1.audioPlayer.playAudio('', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-316.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-316.mp3');
                        recognizedWords.current = [];
                        handleAnswer(isCorrect, false);
                    }
                    else if (!isCorrect && checkOrder(newOptions === null || newOptions === void 0 ? void 0 : newOptions.filter(word => !rightWord.includes(word)), recognizedWords.current) && !((_d = (_c = checkButtonRef === null || checkButtonRef === void 0 ? void 0 : checkButtonRef.current) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.isChecked)) {
                        wrongAnswerCount.current++;
                        audioPlayer_1.audioPlayer.stopAudio();
                        audioPlayer_1.audioPlayer.playAudio('', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-318.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-318.mp3');
                        recognizedWords.current = [];
                        handleAnswer(isCorrect, false);
                    }
                    else if (!isCorrect && !(recognizedWords.current.includes(rightWord[0]) || recognizedWords.current.includes(rightWord[2])) && checkWordsInArrays(recognizedWords === null || recognizedWords === void 0 ? void 0 : recognizedWords.current, newOptions) && !((_f = (_e = checkButtonRef === null || checkButtonRef === void 0 ? void 0 : checkButtonRef.current) === null || _e === void 0 ? void 0 : _e[index]) === null || _f === void 0 ? void 0 : _f.isChecked)) {
                        wrongAnswerCount.current++;
                        audioPlayer_1.audioPlayer.stopAudio();
                        audioPlayer_1.audioPlayer.playAudio('', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-317.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-317.mp3');
                        recognizedWords.current = [];
                        handleAnswer(isCorrect, false);
                    }
                }, timer ? 8000 : (isLongText ? 6000 : 3000));
            }
            else {
                newRepeatAgain = setTimeout(() => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                    if ((response === null || response === void 0 ? void 0 : response.slug) === 'chasti-tela') {
                        if (!isCorrect) {
                            wrongAnswerCount.current++;
                            audioPlayer_1.audioPlayer.stopAudio();
                            audioPlayer_1.audioPlayer.playAudio('', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-318.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-316.mp3');
                            recognizedWords.current = [];
                            handleAnswer(false, false);
                        }
                        return;
                    }
                    else {
                        if (!isCorrect && recognizedWords.current.includes((_b = (_a = data[index || currentCardIndex]) === null || _a === void 0 ? void 0 : _a.right_word) === null || _b === void 0 ? void 0 : _b.toLowerCase()) && !((_d = (_c = checkButtonRef === null || checkButtonRef === void 0 ? void 0 : checkButtonRef.current) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.isChecked)) {
                            wrongAnswerCount.current++;
                            audioPlayer_1.audioPlayer.stopAudio();
                            audioPlayer_1.audioPlayer.playAudio('', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-316.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-316.mp3');
                            recognizedWords.current = [];
                            handleAnswer(isCorrect, false);
                        }
                        else if (!isCorrect && checkOrder(newOptions === null || newOptions === void 0 ? void 0 : newOptions.filter(word => { var _a, _b; return ![(_b = (_a = data[index || currentCardIndex]) === null || _a === void 0 ? void 0 : _a.right_word) === null || _b === void 0 ? void 0 : _b.toLowerCase()].includes(word); }), recognizedWords.current) && !((_f = (_e = checkButtonRef === null || checkButtonRef === void 0 ? void 0 : checkButtonRef.current) === null || _e === void 0 ? void 0 : _e[index]) === null || _f === void 0 ? void 0 : _f.isChecked)) {
                            wrongAnswerCount.current++;
                            audioPlayer_1.audioPlayer.stopAudio();
                            audioPlayer_1.audioPlayer.playAudio('', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-318.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-318.mp3');
                            recognizedWords.current = [];
                            handleAnswer(isCorrect, false);
                        }
                        else if (!isCorrect && !recognizedWords.current.includes((_h = (_g = data[index || currentCardIndex]) === null || _g === void 0 ? void 0 : _g.right_word) === null || _h === void 0 ? void 0 : _h.toLowerCase()) && checkWordsInArrays(recognizedWords === null || recognizedWords === void 0 ? void 0 : recognizedWords.current, newOptions) && !((_k = (_j = checkButtonRef === null || checkButtonRef === void 0 ? void 0 : checkButtonRef.current) === null || _j === void 0 ? void 0 : _j[index]) === null || _k === void 0 ? void 0 : _k.isChecked)) {
                            wrongAnswerCount.current++;
                            audioPlayer_1.audioPlayer.stopAudio();
                            audioPlayer_1.audioPlayer.playAudio('', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-317.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-317.mp3');
                            recognizedWords.current = [];
                            handleAnswer(isCorrect, false);
                        }
                    }
                }, timer ? 8000 : (isLongText ? 6000 : 4100));
            }
        };
        const handleCorrectAnswer = (customIndex, customCurrentCardIndex) => {
            clearInterval(timeoutId);
            clearTimeout(newRepeatAgain);
            recognizedWords.current = [];
            wrongAnswerCount.current = 0;
            if (!['Povtory_glagoly_1', 'Povtory_predlogi_room'].includes(response === null || response === void 0 ? void 0 : response.slug)) {
                setCheckButtons((prevButtons) => {
                    const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
                    if (indexToUpdate === -1) {
                        checkButtonRef.current = prevButtons;
                        checkedAnswers = prevButtons;
                        return prevButtons;
                    }
                    const updatedData = prevButtons.map((button, idx) => {
                        if ((idx === indexToUpdate) && idx === (index || currentCardIndex)) {
                            return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: isCorrect });
                        }
                        return button;
                    });
                    checkButtonRef.current = updatedData;
                    checkedAnswers = updatedData;
                    return updatedData;
                });
            }
            handleAnswer(isCorrect, false);
            if (newRepeatAgain) {
                clearTimeout(newRepeatAgain);
            }
            if (timeoutId) {
                clearInterval(timeoutId);
            }
        };
        if (isCorrect) {
            stopRecognition();
            handleCorrectAnswer(index, currentCardIndex);
        }
        else {
            handleIncorrectAnswer();
        }
    };
    (0, react_1.useEffect)(() => {
        return () => {
            if (recognizer) {
                recognizer.stop();
            }
            document.removeEventListener('recognizeWordEvent', (e) => handleRecognizeWordEvent(e, ['']));
        };
    }, [recognizer]);
    const handleButtonClick = () => __awaiter(void 0, void 0, void 0, function* () {
        var _h, _j;
        if (!isDisabled) {
            if (isRecognizing) {
                stopRecognition();
                // @ts-ignore
                window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                // @ts-ignore
                (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswers);
            }
            else {
                startRecognition([(_j = (_h = data[index || currentCardIndex]) === null || _h === void 0 ? void 0 : _h.right_word) === null || _j === void 0 ? void 0 : _j.toLowerCase()], data[index || currentCardIndex], index || currentCardIndex);
            }
        }
    });
    const handleAnswer = (isCorrect, isTimer) => {
        var _a;
        if (['Povtory_glagoly_1', 'Povtory_predlogi_room'].includes(response === null || response === void 0 ? void 0 : response.slug)) {
            const updatedData = data === null || data === void 0 ? void 0 : data.map((item, idx) => {
                if ((isCorrect) && ((index || currentCardIndex) === idx)) {
                    return (Object.assign(Object.assign({}, item), { isCorrect: true, isChecked: true }));
                }
                return item;
            });
            setData(updatedData);
        }
        if (isCorrect) {
            if (['Povtory_glagoly_1', 'Povtory_predlogi_room'].includes(response === null || response === void 0 ? void 0 : response.slug)) {
                setCheckButtons((prevButtons) => {
                    const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
                    if (indexToUpdate === -1) {
                        checkButtonRef.current = prevButtons;
                        checkedAnswers = prevButtons;
                        return prevButtons;
                    }
                    const updatedData = prevButtons.map((button, idx) => {
                        if ((idx === indexToUpdate) && idx === (index || currentCardIndex)) {
                            return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: isCorrect });
                        }
                        return button;
                    });
                    checkButtonRef.current = updatedData;
                    return updatedData;
                });
            }
            wrongAnswerCount.current = 0;
            if (newRepeatAgain) {
                clearTimeout(newRepeatAgain);
            }
            if (timeoutId) {
                clearInterval(timeoutId);
            }
            handleAddCoin();
            if (!data[index + 1]) {
                setIsRecognizing(false);
                // index = 0;
                // setData(initialData);
                stopRecognition();
                //@ts-ignore
                window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                // @ts-ignore
                (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswers);
            }
            setTimeout(() => {
                var _a, _b, _c;
                const nextIndex = index + 1;
                recognizedWords.current = [];
                if (data[nextIndex]) {
                    const newData = [...infoRep];
                    let timeOfRepetition = (Date.now() - ((_a = newData[index]) === null || _a === void 0 ? void 0 : _a.startTime)) / 1000;
                    newData[(newData === null || newData === void 0 ? void 0 : newData.length) - 1] = Object.assign(Object.assign({}, newData[(newData === null || newData === void 0 ? void 0 : newData.length) - 1]), { category_name: isCorrect ? uiConfigs_2.categoryIds[uiConfigs_2.categoriesName.correct] : uiConfigs_2.categoryIds[uiConfigs_2.categoriesName.incorrect], system_time: parseFloat(timeOfRepetition.toFixed(1)) });
                    setCurrentCardIndex(nextIndex);
                    infoRep = newData;
                    index = nextIndex;
                    // if(customAnswer) {
                    setCustomAnswer(prev => prev ? '' : prev);
                    // }
                    // setAnswerOptions([data[nextIndex]?.answer?.toLowerCase()]);
                    stopRecognition();
                    startRecognition([(_c = (_b = data[nextIndex]) === null || _b === void 0 ? void 0 : _b.right_word) === null || _c === void 0 ? void 0 : _c.toLowerCase()], data[nextIndex], nextIndex);
                }
                else {
                    // console.log('Конец карточек!');
                    // setCurrentCardIndex(0)
                    // setCheckButtons(initialButtonState);
                    setIsRecognizing(false);
                    // index = 0;
                    // setData(initialData);
                    stopRecognition();
                    //@ts-ignore
                    window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                    // @ts-ignore
                    (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswers);
                }
            }, 4000);
        }
        else {
            console.debug(wrongAnswerCount, 'wrongAnswerCount');
            recognizedWords.current = [];
            if (wrongAnswerCount.current >= 3) {
                const nextIndex = index + 1;
                console.debug(nextIndex, data === null || data === void 0 ? void 0 : data.length, 'next index');
                if (nextIndex >= (data === null || data === void 0 ? void 0 : data.length)) {
                    // @ts-ignore
                    window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                    // @ts-ignore
                    (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswers);
                }
                else {
                    const newData = [...infoRep];
                    let timeOfRepetition = (Date.now() - ((_a = newData[index]) === null || _a === void 0 ? void 0 : _a.startTime)) / 1000;
                    newData[(newData === null || newData === void 0 ? void 0 : newData.length) - 1] = Object.assign(Object.assign({}, newData[(newData === null || newData === void 0 ? void 0 : newData.length) - 1]), { category_name: isCorrect ? uiConfigs_2.categoryIds[uiConfigs_2.categoriesName.correct] : uiConfigs_2.categoryIds[uiConfigs_2.categoriesName.incorrect], system_time: parseFloat(timeOfRepetition.toFixed(1)) });
                    infoRep = newData;
                }
                setCheckButtons((prevButtons) => {
                    const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
                    if (indexToUpdate === -1) {
                        checkButtonRef.current = prevButtons;
                        checkedAnswers = prevButtons;
                        return prevButtons;
                    }
                    // audioPlayer.stopAudio()
                    // audioPlayer.playAudio(AudioPathNames.Incorrect)
                    const updatedData = prevButtons.map((button, idx) => {
                        if (idx === indexToUpdate && idx === (index || currentCardIndex)) {
                            return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: false });
                        }
                        return button;
                    });
                    checkButtonRef.current = updatedData;
                    checkedAnswers = updatedData;
                    return updatedData;
                });
                recognizedWords.current = [];
                wrongAnswerCount.current = 0;
                stopRecognition();
                const updatedData = data === null || data === void 0 ? void 0 : data.map((item, idx) => {
                    if (index === idx) {
                        return (Object.assign(Object.assign({}, item), { isCorrect: false, isChecked: true }));
                    }
                    return item;
                });
                // if(wrongAnswerCount === 3) {
                audioPlayer_1.audioPlayer.stopAudio();
                audioPlayer_1.audioPlayer.playAudio('x', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-315.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-315.mp3'); // Correct word
                setTimeout(() => {
                    var _a;
                    // if(wrongAnswerCount === 3) {
                    audioPlayer_1.audioPlayer.stopAudio();
                    audioPlayer_1.audioPlayer.playAudio('x', (_a = data[index || currentCardIndex]) === null || _a === void 0 ? void 0 : _a.right_audio);
                    wrongAnswerCount.current = 0;
                    // }
                }, 2000);
                // }
                setData(updatedData);
                setTimeout(() => {
                    var _a, _b;
                    if (data[nextIndex]) {
                        index = nextIndex;
                        recognizedWords.current = [];
                        setCurrentCardIndex(nextIndex);
                        setCustomAnswer(prev => prev ? '' : prev);
                        stopRecognition();
                        startRecognition([(_b = (_a = data[nextIndex]) === null || _a === void 0 ? void 0 : _a.right_word) === null || _b === void 0 ? void 0 : _b.toLowerCase()], data[nextIndex], nextIndex);
                    }
                }, 4500);
            }
            else {
                console.debug(wrongAnswerCount, 'wrongAnswerCount else statement');
                if (wrongAnswerCount.current !== 3 && isTimer) {
                    audioPlayer_1.audioPlayer.stopAudio();
                    audioPlayer_1.audioPlayer.playAudio('x', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-317.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-317.mp3');
                }
            }
            // } else {
            //     console.log('Неправильно, попробуй ещё раз');
            // }
        }
    };
    const windowWidth = (0, useWindowWidrh_1.default)();
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (response) {
            setTitle((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.title);
            setData((_c = (_b = response === null || response === void 0 ? void 0 : response.text) === null || _b === void 0 ? void 0 : _b.offers) === null || _c === void 0 ? void 0 : _c.sort((a, b) => a.order - b.order));
            setCheckButtons((0, helpers_1.generateInitialState)((_e = (_d = response === null || response === void 0 ? void 0 : response.text) === null || _d === void 0 ? void 0 : _d.offers) === null || _e === void 0 ? void 0 : _e.length));
            checkButtonRef.current = (0, helpers_1.generateInitialState)((_g = (_f = response === null || response === void 0 ? void 0 : response.text) === null || _f === void 0 ? void 0 : _f.offers) === null || _g === void 0 ? void 0 : _g.length);
            checkedAnswers = (0, helpers_1.generateInitialState)((_j = (_h = response === null || response === void 0 ? void 0 : response.text) === null || _h === void 0 ? void 0 : _h.offers) === null || _j === void 0 ? void 0 : _j.length);
            setInitialData((_l = (_k = response === null || response === void 0 ? void 0 : response.text) === null || _k === void 0 ? void 0 : _k.offers) === null || _l === void 0 ? void 0 : _l.sort((a, b) => a.order - b.order));
            if ((_o = (_m = response === null || response === void 0 ? void 0 : response.text) === null || _m === void 0 ? void 0 : _m.offers) === null || _o === void 0 ? void 0 : _o.some(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.content) === null || _a === void 0 ? void 0 : _a.length) >= 6; })) { //TODO if (response?.text?.offers?.some(item => item?.content?.length >= 6)) {
                setIsLongText(true);
            }
        }
    }, [response]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        windowWidth <= 1200 ? react_1.default.createElement(smallHeader_1.default, { exerciseName: title }) : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            windowWidth <= 1200 ? react_1.default.createElement(react_1.default.Fragment, null) : react_1.default.createElement(title_1.default, { text: title, hasSmallText: true }),
            react_1.default.createElement(exercise_1.ExerciseWrapper, { wihMargin: windowWidth <= 1200 },
                react_1.default.createElement(Description, null, description || ''),
                react_1.default.createElement(DropContainerWrapper, null,
                    react_1.default.createElement(boxComponentWithImg_1.default, { isDisinhibition: true, list: [data[index || currentCardIndex]], customAnswer: customAnswer }),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(Pagination_1.Pagination, null, checkButtons.map((item, index) => react_1.default.createElement(Pagination_1.PaginationItem, { key: index, item: item, active: item.isCorrect && item.isChecked ? "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)" : !item.isCorrect && item.isChecked ? "#FF1431" : null })))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(button_1.default, { isShowShadow: true, isStarted: isRecognizing, label: getLabel(), onClick: handleButtonClick, isCheckButton: false }))))));
};
exports.default = Disinhibition;
